import { Text } from '@dixa/lib-shared-habla';

import { ConversationAutomationAuditLogEntry } from 'apis/auditLogs';

export type RoutedThroughInternalNoteProps = {
  node: ConversationAutomationAuditLogEntry<'AUTOMATION_INTERNAL_NOTE_NODE_VISITED'>;
};

export function RoutedThroughInternalNote(
  _props: RoutedThroughInternalNoteProps,
): JSX.Element {
  return (
    <Text.Paragraph>
      Internal note · Automation visited internal note action
    </Text.Paragraph>
  );
}
